var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { Tag } from 'syf-component-library/ui/atoms';
import theme from '../../../theme';
import { t } from '../../../strings/i18n/i18n';
import getTranslationForTransactionStatus from '../../../helpers/getTranslationForTransactionStatus';
import { TransactionStatus } from '../../../const/transactionStatus';
import Icon from '../../atoms/Icon';
var _b = theme.colors, denimBlue = _b.denimBlue, darkYellow = _b.darkYellow, greenText = _b.greenText, _c = theme.statusColors, yellowFlag = _c.yellowFlag, yellowBground = _c.yellowBground, blueBground = _c.blueBground, greenBground = _c.greenBground;
var blueFlagColors = {
    textColor: denimBlue,
    flagColor: denimBlue,
    backgroundColor: blueBground
};
var yellowFlagColors = {
    textColor: darkYellow,
    flagColor: yellowFlag,
    backgroundColor: yellowBground
};
var greenFlagColors = {
    textColor: greenText,
    flagColor: greenText,
    backgroundColor: greenBground
};
var TransactionsStatusFlagColors = (_a = {},
    _a[TransactionStatus.SET_1] = yellowFlagColors,
    _a[TransactionStatus.SET_2] = yellowFlagColors,
    _a[TransactionStatus.SET_3] = yellowFlagColors,
    _a[TransactionStatus.SET_4] = yellowFlagColors,
    _a[TransactionStatus.SET_5] = yellowFlagColors,
    _a[TransactionStatus.SET_6] = yellowFlagColors,
    _a[TransactionStatus.SET_7] = yellowFlagColors,
    _a[TransactionStatus.SET_8] = greenFlagColors,
    _a[TransactionStatus.SET_9] = greenFlagColors,
    _a[TransactionStatus.SET_10] = greenFlagColors,
    _a[TransactionStatus.SET_11] = greenFlagColors,
    _a[TransactionStatus.SET_12] = greenFlagColors,
    _a[TransactionStatus.SET_13] = greenFlagColors,
    _a[TransactionStatus.SET_14] = greenFlagColors,
    _a[TransactionStatus.SET_15] = greenFlagColors,
    _a[TransactionStatus.SET_16] = greenFlagColors,
    _a[TransactionStatus.SET_17] = greenFlagColors,
    _a[TransactionStatus.SET_18] = greenFlagColors,
    _a[TransactionStatus.SET_19] = greenFlagColors,
    _a[TransactionStatus.SET_20] = greenFlagColors,
    _a[TransactionStatus.SET_21] = blueFlagColors,
    _a[TransactionStatus.SET_22] = yellowFlagColors,
    _a[TransactionStatus.SET_23] = greenFlagColors,
    _a[TransactionStatus.SET_24] = greenFlagColors,
    _a[TransactionStatus.SET_25] = greenFlagColors,
    _a);
var ActivityTagContainer = styled(Tag)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & > span {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n  }\n"], ["\n  & > span {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n  }\n"])));
var ActivityTag = function (_a) {
    var className = _a.className, status = _a.status;
    var translation = getTranslationForTransactionStatus(status);
    if (!translation) {
        return null;
    }
    var _b = TransactionsStatusFlagColors[status], textColor = _b.textColor, flagColor = _b.flagColor, backgroundColor = _b.backgroundColor;
    return (_jsx(ActivityTagContainer, { className: className, "data-cy": "activity-tag", content: t(translation), icon: _jsx(Icon, { name: "faFlag", color: flagColor, fontSize: 12 }), backgroundColor: backgroundColor, textColor: textColor }));
};
export default ActivityTag;
var templateObject_1;
//# sourceMappingURL=index.js.map